import {AccountPlan, PurchaseItem} from '../../model'
import {_, t, useCurrentWorkspaceState} from '..'
import {selectPurchase} from '../../store'
import {IPurchase} from '../../shared/db/purchase'
import {ProductPlan} from '../../shared/db/product'

export interface AccountPlanState {
  accountPlan?: ProductPlan | 'free'
  purchase?: IPurchase | null
  hasActivePlanPurchase?: boolean
}

/**
 * Get the target purchase/plan that make sense:
 *
 * filter purchases that has plan -> sort by expire time ┬> if no purchases  -> free
 *                                                       ├> if all expired   -> get the latest purchase
 *                                                       └> if active exists -> get the highest plan purchase
 *
 * most plan usages should be refactored to use product capabilities in the future
 */
export const useCurrentWorkspaceAccountPlan = (arg?: {projectId?: string}): AccountPlanState => {
  const purchaseState = selectPurchase()
  const {workspaceId} = useCurrentWorkspaceState({projectId: arg?.projectId})
  if (!workspaceId) {
    return {}
  } else {
    const purchaseList = purchaseState[workspaceId] || []
    const planPurchaseList = purchaseList.filter((purchase) => purchase.product?.plan)
    if (planPurchaseList.length === 0) {
      return {accountPlan: 'free', purchase: undefined, hasActivePlanPurchase: false}
    } else {
      const target = planPurchaseList.reduce((target: IPurchase, purchaseItem) => {
        // should be refactored if we have more then 3 plans
        console.log('check12', purchaseItem)
        if (purchaseItem.product?.plan === ProductPlan.Advanced) {
          return purchaseItem
        }
        return target
      }, planPurchaseList[0])
      return {accountPlan: t.unwrap(target.product?.plan), purchase: target, hasActivePlanPurchase: true}
    }
  }
}
